// extracted by mini-css-extract-plugin
export default {"buttonRow":"YesCancelDialog_buttonRow__+dhAG","w120":"YesCancelDialog_w120__bShnH","subtitle":"YesCancelDialog_subtitle__bZBgj"};